/* ==========================================================================
   Shiok Globo Guard
   --------------------------------------------------------------------------
   Pengaman di atas Globo Product Options. Config (variant id ke aturan) dan
   alasannya ada di snippets/shiok-gpo-guard.liquid.

   Cara kerjanya:
   - Add to cart semua form tema lewat ProductForm.onSubmitHandler
     (component-product-form.js), listener submit di form itu sendiri. Listener
     submit di document fase CAPTURE jalan lebih dulu, jadi di sinilah add
     ditolak, sebelum /cart/add.js dipanggil. Globo tidak punya request add
     sendiri (dicek 2026-10-04).
   - Yang dibaca dari Globo hanya .gpo-app, radio dropdown yang :checked, dan
     input di .gpo-hidden-inputs. Kalau Globo mengubah markup itu, guard tidak
     menemukan apa-apa dan diam (fail open), pelanggan tetap bisa beli.
   - Semua teks yang dilihat pelanggan berbahasa Inggris.
   ========================================================================== */

(function () {
  'use strict';

  var CFG;
  try {
    CFG = JSON.parse(document.getElementById('shiok-gpo-guard-config').textContent);
  } catch (e) {
    return;
  }

  function ruleFor(form) {
    var id = form.querySelector('[name="id"]');
    return id ? CFG[id.value] : null;
  }

  // "3 bottles" = 3, "24 bottles + 1 Free" = 25
  function packSize(title) {
    return (title.match(/\d+/g) || []).reduce(function (s, n) { return s + parseInt(n, 10); }, 0);
  }

  // A "0" choice, if one is added in Globo admin, counts as nothing.
  function picked(app) {
    var n = 0;
    app.querySelectorAll('input[data-type="dropdown"]:checked').forEach(function (r) {
      n += parseInt(r.value, 10) || 0;
    });
    return n;
  }

  function noteText(want, got) {
    var head = got + ' of ' + want + ' bottles picked.';
    if (got < want) return head + ' Pick ' + (want - got) + ' more.';
    if (got > want) return head + ' Remove ' + (got - want) + '.';
    return head;
  }

  /* Only writes when something changed: the MutationObserver below watches the
     whole page, and an unconditional write would wake it up every frame. */
  function renderNote(form, app, want, got) {
    var note = form.querySelector('.sgg-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'sgg-note';
      note.setAttribute('role', 'status');
      note.style.cssText = 'margin:8px 0 16px;font-weight:600;';
      app.parentNode.insertBefore(note, app.nextSibling);
    }
    var text = noteText(want, got);
    if (note.textContent !== text) note.textContent = text;
    var bad = got > want || (got !== want && form.hasAttribute('data-sgg-tried'));
    note.style.color = bad ? '#B5491D' : '';
    return note;
  }

  function refresh() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var rule = ruleFor(form);
      var app = form.querySelector('.gpo-app');
      if (!rule || !app) return;
      if ('show' in rule) {
        var display = rule.show ? '' : 'none';
        if (app.style.display !== display) app.style.display = display;
        return;
      }
      renderNote(form, app, packSize(rule.pack), picked(app));
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; refresh(); });
  }
  // Globo renders late, and the v2 variant pills change the id input without
  // firing any event, so watch the page and re-check after every click.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', function () { setTimeout(schedule, 0); }, true);
  schedule();

  function stop(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var rule = ruleFor(form);
    if (!rule) return;
    var app = form.querySelector('.gpo-app');

    // Quick view has no Globo widget, so the choices can only be made on the product page.
    if (!app) {
      stop(e);
      window.location.href = rule.url;
      return;
    }

    var off = [];
    if ('show' in rule) {
      // Variant without the extra (Lob Lob without lobster): send none of the widget's fields.
      if (!rule.show) off = form.querySelectorAll('.gpo-app input, .gpo-hidden-inputs input');
    } else {
      var want = packSize(rule.pack);
      if (picked(app) !== want) {
        stop(e);
        form.setAttribute('data-sgg-tried', '');
        var note = renderNote(form, app, want, picked(app));
        note.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      off = [].filter.call(form.querySelectorAll('.gpo-hidden-inputs input'), function (i) { return i.value === '0'; });
    }

    /* ProductForm serialises the form synchronously inside its own submit
       listener, which runs right after this one, and skips disabled fields.
       Re-enabled on the next tick so Globo's own state is left as it was. */
    off = [].filter.call(off, function (i) { return !i.disabled; });
    off.forEach(function (i) { i.disabled = true; });
    setTimeout(function () { off.forEach(function (i) { i.disabled = false; }); }, 0);
  }, true);
})();
